// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};